module.exports = __webpack_public_path__ + "img/login_blue_middle.d9221a8d.png";